import React from 'react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui/Card';
import { useTranslation } from '../i18n';
export function PatientPrivacyNoticePage() {
  const {
    t
  } = useTranslation();
  return <Layout data-id="element-1875">
      <section className="bg-teal-900 text-white py-16" data-id="element-1876">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1877">
          <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1878">
            Patient Privacy Notice
          </h1>
          <p className="text-teal-100" data-id="element-1879">Last updated: 5 February 2026</p>
        </div>
      </section>

      <section className="py-16 bg-gray-50" data-id="element-1880">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1881">
          <Card className="p-8 md:p-12 prose prose-teal max-w-none" data-id="element-1882">
            <p className="lead" data-id="element-1883">
              Dentico Dental Clinic Ltd is responsible for your personal data.
            </p>

            <h3 data-id="element-1884">
              When you request an appointment or become our patient, we may
              collect:
            </h3>
            <ul data-id="element-1885">
              <li data-id="element-1886">contact details,</li>
              <li data-id="element-1887">appointment and administrative details,</li>
              <li data-id="element-1888">
                relevant health information needed to provide safe dental care.
              </li>
            </ul>

            <h3 data-id="element-1889">We use your data to:</h3>
            <ul data-id="element-1890">
              <li data-id="element-1891">provide dental care and manage appointments,</li>
              <li data-id="element-1892">communicate about treatment and follow-up,</li>
              <li data-id="element-1893">
                comply with legal, regulatory, and professional obligations.
              </li>
            </ul>

            <h3 data-id="element-1894">Data Sharing</h3>
            <p data-id="element-1895">
              We do not sell your data. We may share data with trusted providers
              (e.g. booking/IT systems, laboratories, advisers) where necessary
              and lawful.
            </p>

            <h3 data-id="element-1896">Your Rights</h3>
            <p data-id="element-1897">
              You have data protection rights under UK law, including access,
              correction, objection/restriction, and withdrawal of consent where
              consent is used.
            </p>

            <div className="bg-teal-50 p-6 rounded-xl mt-8 not-prose" data-id="element-1898">
              <h3 className="text-lg font-bold text-teal-900 mb-4" data-id="element-1899">
                Contact Us
              </h3>
              <div className="space-y-2 text-teal-800" data-id="element-1900">
                <p data-id="element-1901">
                  <strong data-id="element-1902">Email:</strong>{' '}
                  <a href="mailto:info@denticoclinic.co.uk" className="hover:underline" data-id="element-1903">
                    info@denticoclinic.co.uk
                  </a>
                </p>
                <p data-id="element-1904">
                  <strong data-id="element-1905">Address:</strong> 360–364 City Road, London EC1V 2PY
                </p>
                <p data-id="element-1906">
                  <strong data-id="element-1907">Phone:</strong> +44 7345 197820
                </p>
              </div>
            </div>
          </Card>
        </div>
      </section>
    </Layout>;
}